module.exports = __webpack_public_path__ + "img/68.29f8dac5.png";